// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"39":"a1c56b6d62388bbd","323":"5859895c13df1f59","401":"72b8eb9748452198","443":"dbc8315ce8f946bd","726":"03ba35e2812749f3"}[chunkId] + ".1701060228836.js";
};